import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import store from './store';
// import Vant from 'vant';
// import 'vant/lib/index.css';

// Vue.use(Vant);


// el-dialog 默认点击遮照为不关闭
(ElementUI.Dialog as any).props.closeOnClickModal.default = false;
Vue.use(ElementUI, {
    size: 'mini'
});
Vue.prototype.$notify = '';
// 引入element-ui的全局样式
import 'element-ui/lib/theme-chalk/index.css';
// 引入全局样式
import './assets/css/common.scss';
// 引入iconfont 图标
/* import './assets/icon/iconfont.css';
import './assets/icon/iconfont.js'; */
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
// 引入全局组件
import './components/global/index';
// 过滤器引入
import '@/common/filter/index';
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')